import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import EditIcon from '@mui/icons-material/Edit';
import { InputLabel, Stack, TextField } from '@mui/material';
import axios from 'axios';



export default function EditModal({ word, close, show }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => { setOpen(false); close(); };
  const [submit, setSubmit] = React.useState(false)
  const [text, setText] = React.useState("");
  const [wordCount, setWordCount] = React.useState(0);
  const dashboard_backend = process.env.REACT_APP_DASHBOARD_BACKEND
  const handleChange = (event) => {
    const inputValue = event.target.value;

    // Split the input into words, filtering out empty strings
    const words = inputValue.trim().split(/\s+/).filter((word) => word.length > 0);

    if (words.length <= 10) {
      setText(inputValue);
      setWordCount(words.length);
    }
  };

  const handleSubmit = async () => {
    setSubmit(true)
    const team_id = localStorage.getItem('team_id')
    try {
      const response = await axios.post(`${dashboard_backend}/documents/editMeaning/`, { word: word, meaning: text, team_id: team_id }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      })

      setTimeout(() => {
        handleClose()
        setSubmit(false)
        setWordCount(0)
        setText("")
        close()
      }, 1500)

    } catch (err) {
      console.log(err)
      setTimeout(() => {
        handleClose()
        setSubmit(false)
        
      }, 2000)
      
    }

  }

  return (
    <div style={{ display: 'inline-block' }} >
      {/* <EditIcon sx={{fontSize:'18px',marginLeft:"5px",cursor:'pointer'}} onClick={handleOpen}/> */}
      <Modal 
        open={show}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 1501 }}
      >
        <Box className="shadow-none " sx={{
          padding: !submit ? '20px' : '0px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '300px',
          height: "auto",
          bgcolor: '#EDE6EE',
          borderRadius: '10px'
        }}>
          {!submit && <>
            <InputLabel className='pb-4' htmlFor="component-simple" sx={{ padding: '5px 0px', color: '#333333' }}>Change Meaning</InputLabel>

            <textarea placeholder="Enter you desired meaning" className='border-2 border-solid border-[black] bg-[#EDE6EE] w-full p-4 h-full h-[147px] rounded-lg' style={{ resize: "none", }} label="Enter up to 10 words" id="component-simple" variant="standard" value={text} sx={{ width: '100%' }} onChange={handleChange} />
            <div className='flex justify-end pt-4'>
              <button onClick={() => handleClose()} className=" p-2 px-4 text-[#68548E] text-[16px] ">Close</button>
              <button onClick={() => handleSubmit()} className=' !rounded-full p-2 px-4 !bg-[#68548E] !normal-case !text-[#ffffff]'>Submit</button>
              
            </div>

          </>}
          {submit &&
            <div  id="modal-modal-description " className=" rounded-lg flex bg-[#B2F1C1] p-2" style={{ mt: 2, position:"absolute", bottom: "-220px",left:"14%" }}>
              <svg className=" mx-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="#00210E" />
              </svg>

              Change requested</div>}
        </Box>
      </Modal>
    </div >
  );
}